const routes = {
    home: '/',
    login: '/login',
    signup: '/signup',
    dashboard: '/dashboard',
    forgotPassword: '/password',
    products: '/our-products',
    productsCategories: (category)=>"/pro-category/".concat(category.slug),
    product: (product)=>"/product/".concat(product.slug),
    compare: (product)=>"/compare/".concat(product.slug),
    whereToBuy: "/where-to-buy",
    partners: '/partners',
    support: '/support',
    contactUs: '/contact-us',
    news: '/updates',
    blog: (post)=>"/updates/".concat(post.slug),
    privacyPolicy: '/privacy-policy',
    documents: '/documents',
    categoryDocuments: (category)=>"/documents/".concat(category.slug),
    productSelector: '/products',
    accessorySelector: '/accessories',
    faq: '/faq',
    tools: '/tools',
    cctvCalculator: '/cctv-calculator'
};
export default routes;
